/**
 * What's New copy for CrewPilot 1.0.
 *
 * Independent from productEducation so this presentation layer never alters
 * Ashley briefings or guided tours.
 *
 * Scene ids select the existing illustration, except Billing, which has its
 * own invoice miniature. Projects uses the pictures gallery. Conversations
 * keeps the project stack. Card order is the 1.0 story.
 */

export const WHATS_NEW_SCENES = Object.freeze([
  {
    id: "offline",
    eyebrow: "Offline",
    title: "Ready when the signal isn’t.",
    accent: "signal isn’t.",
    body: "Work you’ve opened can stay available offline. Favorite the projects you’ll need so CrewPilot prepares those on purpose.",
    footnote: "Favorite a project · Prepare for offline · Keep working · Sync when connected",
    nav: "Favorites and offline",
  },
  {
    id: "navigation",
    eyebrow: "Home",
    title: "A smarter Home.",
    accent: "Home.",
    body: "See what needs attention, today, project health, tasks, planning, estimates, finances, and recent activity.",
    footnote: "Move, hide, restore, or reset any section. You arrange Home yourself.",
    nav: "Home",
  },
  {
    id: "planning",
    eyebrow: "Planning",
    title: "Planning and tasks, connected.",
    accent: "connected.",
    body: "Start from the calendar. Occupied days show a count. Open a task and come back, or jump to that project’s task list.",
    footnote: "Keep upcoming work visible, from Planning to the job.",
    nav: "Planning",
  },
  {
    id: "redesign",
    eyebrow: "Conversations",
    title: "Project conversations.",
    accent: "conversations.",
    body: "Capture a project conversation by voice or typing. AI-enhanced review picks out details and suggests tasks.",
    footnote: "You approve a suggestion before it becomes a real project task.",
    nav: "Conversations",
  },
  {
    id: "billing",
    eyebrow: "Billing",
    title: "Billing and cash flow.",
    accent: "cash flow.",
    body: "Create invoices, record partial payments, and see Paid, Balance, and the payment history.",
    footnote: "Receivables and client statements show what is still owed.",
    nav: "Billing",
  },
  {
    id: "pictures",
    eyebrow: "Projects",
    title: "Projects and client experience.",
    accent: "client experience.",
    body: "Pictures stay with the project, along with its locations, measurements, and tasks.",
    footnote: "Client View is a read-only share. Include billing only if you want to.",
    nav: "Projects",
  },
]);

export const WHATS_NEW_COPY = Object.freeze({
  skip: "Skip",
  next: "Next",
  finish: "Get to work",
  replayHint: "Reopen anytime in Settings → What’s New.",
  dontShowAgain: "Don’t show again",
  dontShowAgainHint: "Won’t open automatically. Always in Settings.",
  dialogLabel: "What’s new in CrewPilot",
});
